import { render, staticRenderFns } from "./EnlacePersona.vue?vue&type=template&id=7b2b56ef&scoped=true&lang=pug"
import script from "./EnlacePersona.vue?vue&type=script&lang=js"
export * from "./EnlacePersona.vue?vue&type=script&lang=js"
import style0 from "./EnlacePersona.vue?vue&type=style&index=0&id=7b2b56ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2b56ef",
  null
  
)

export default component.exports